import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, Package } from 'types';
import { client } from 'utils/api-client';

export default function useClonePackage(): UseMutationResult<
  AxiosResponse<Package>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const clonePackage = (packageId: string): Promise<AxiosResponse<Package>> => {
    return client.put(`packages/${packageId}/clone/`);
  };

  return useMutation(clonePackage, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['billingPlans'],
      });
      queryClient.invalidateQueries({
        queryKey: ['packages'],
      });
    },
  });
}
